import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { MdlFiltroPage } from 'src/app/pages/mdl-filtro/mdl-filtro.page';
import { MdlResEncuestasPage } from 'src/app/pages/mdl-res-encuestas/mdl-res-encuestas.page';
import { MasivosService } from 'src/app/services/masivos.service';
import { RespuestasRapidasService } from 'src/app/services/respuestas-rapidas.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-reporte-encuestas',
  templateUrl: './reporte-encuestas.component.html',
  styleUrls: ['./reporte-encuestas.component.scss'],
})
export class ReporteEncuestasComponent implements OnInit {

  tel = new FormControl('');
  dataFiltro: any;
  arrFiltro: any;
  classUser: any;
  vista: number;
  respuestas: any;
  arrRespuestas: any;
  idAdmin: number;
  totalFiltro: number;
  fechaFinal = new FormControl('');
  fechaInicial = new FormControl('');
  registros: number;
  pagina: number;
  paginacion: number;
  totalPag: number;
  descarga: boolean;
  loading: any;
  enviados: any;
  recibidos: any;
  arrDatos: any;
  mostrarBotonVolver: boolean;

  canal: any;
  canales: any;
  canalInicial: any;
  constructor(
    private modalCtrl: ModalController,
    private storage: Storage,
    private formatdate: DatePipe,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private encuestaService: RespuestasRapidasService,
    private masivosService: MasivosService,
    private router: Router
  ) {
    this.canales = [];
    this.arrDatos = [];
    this.dataFiltro = {};
    this.arrFiltro = {};
    this.respuestas = [];
    this.arrRespuestas = [];
    this.descarga = false;
    this.enviados = 0;
    this.recibidos = 0;
  }

  ngOnInit() {
    this.getCanal();
    // this.getFechaActual();
    // setTimeout(() => {
    //   // this.consulta(0, 0);
    // }, 200);
    this.vista = 1;
    this.respuestas = [];
    this.arrRespuestas = [];
    this.mostrarBotonVolver = this.router.url.includes('masivos');
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    // console.log(this.canales, 'canales ');
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;
  }


  consulta(val, tipoConsulta) {
    // console.log('Entra consulta');
    let pag = this.paginacion;
    let des = 0;
    if (tipoConsulta == 1) {
      pag = 0;
      this.pagina = 1;
    }
    if (this.descarga) {
      pag = 0;
      des = 1;
      this.dataFiltro.nombre = `Reporte-encuestas-${this.formatdate.transform(new Date(), 'dd-MM-yyyy-HH-mm-ss')}`;
      this.presentToast('Descarga completada', 'success');
    }
    if (!this.descarga) {
      this.presentLoading('Cargando conversaciones...');
      // this.loading.dismiss();
    }
    // console.log(this.dataFiltro);
    let query = `&descarga=${des}&nombre${this.dataFiltro.nombre}`;
    if (val > 0) {
      let feIn = new Date(this.fechaInicial.value);
      let feFin = new Date(this.fechaFinal.value);

      if (val === 2) {
        feIn = this.fechaInicial.value;
        feFin = this.fechaFinal.value;
      }
      feIn.toUTCString();
      feFin.toUTCString();
      const dayIn = feIn.getUTCDate();
      const dayFin = feFin.getUTCDate();
      if (val === 2) {
        feIn.setUTCDate(dayIn);
        feFin.setUTCDate(dayFin);
      } else {
        feIn.setUTCDate(dayIn + 1);
        feFin.setUTCDate(dayFin + 1);
      }
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      // console.log(feIn);
      // console.log(feFin);
      query = `&inicio=${feIn}&fin=${feFin}&${this.dataFiltro.numero}&descarga=${des}&nombre=${this.dataFiltro.nombre}`;
    }
    // console.log(query, pag, this.dataFiltro);
    this.encuestaService.consultaReportesEncuestas(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token, query, this.classUser.canale.url_back).subscribe(
      async (res: any) => {
        // console.log(res);
        if (des === 0) {
          await this.loading.dismiss();
        }

        const { status, message } = res;
        if (status === 'success') {
          const { respuestas, total } = res;
          this.registros = total;
          this.totalPag = Math.round(this.registros / 30);
          if (this.registros <= 30) {
            this.totalPag = 1;
          }
          // console.log(this.respuestas,'respuestas');
          this.formatTable(respuestas);
          //  this.conversaciones.forEach(element => {
          //   element.conversacion.createdAt = new Date(element.conversacion.createdAt);
          //  });
          //  console.log(this.conversaciones);
          if (des === 0) {
            await this.loading.dismiss();
            this.presentToast('Datos encontrados!', 'success');
          }

          this.getDatosGrls(query);

          this.vista = 1;
        }
        else {
          this.respuestas = [];
          if (!this.descarga) {
            await this.loading.dismiss();
            this.presentToast('No se encontrarón conversaciones', 'danger');
          }
        }
      },
      erro => {
        console.log(erro);
        if (!this.descarga) {
          this.loading.dismiss();
        }
      });

  }

  formatTable(respuestas) {

    this.respuestas = respuestas.map((respuesta) => {
      if (respuesta.layoutMasiv) {
        const datos = JSON.parse(respuesta.layoutMasiv.datos);
        const dataKey = Object.keys(datos);
        respuesta.datos = {};
        dataKey.forEach(element => {
          if (element.toLocaleLowerCase() != 'whatsapp' && element.toLocaleLowerCase() != 'telefono'
            && element.toLocaleLowerCase() != 'teléfono' && element.toLocaleLowerCase() != 'numero' &&
            element.toLocaleLowerCase() != 'número' && element.toLocaleLowerCase() != 'unique_id') {
            if (!Number(element)) {
              if (!this.arrDatos.includes(element)) {
                this.arrDatos.push(element)
              }
            }
          }
        });
        console.log(datos['unique_id'], 'Datos dinámicos')
        if (this.idAdmin == 47) {
          respuesta.datos.expediente = datos['unique_id'];
        }
        this.arrDatos.forEach(data => {
          // console.log(data.toLocaleLowerCase());
          respuesta.datos[data] = datos[data];
        });
        // respuesta.datos = datos;
      }
      return respuesta;
    });
    // console
    // this.arrRespuestas = respuestas.map((conver) =>( {
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     Telefono: conver.conversacion.numero.numeroCliente,
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     Nombre: conver.nombreCliente,
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     'Inicio de conversación': this.formatdate.transform(conver.conversacion.createdAt, 'dd/MM/yyyy HH:mm:ss'),
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     'Fin de conversación': this.formatdate.transform(conver.finConversacion, 'dd/MM/yyyy HH:mm:ss'),
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     Agente: conver.agente,
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     Resultado: conver.statusConver,
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     Origen: conver.conversacion.origen,
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     'No. conversación': conver.conversacion.conversacion,
    //     // eslint-disable-next-line quote-props
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     'Calificación': conver.calificacion.calificacion,
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     'Otra Respuesta Calificación': conver.calificacion.otraRes,

    // }));
  }

  async openMdlRespuestas(respuesta) {
    const modal = await this.modalCtrl.create({

      component: MdlResEncuestasPage,
      componentProps: {
        respuesta,
        user: this.classUser
        // conversacion,
        // agente,
        // cliente,
        // nombreCliente
      },
      cssClass: ''
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
  }

  getFechaActual() {
    const fechaAc = new Date();
    const f2l = fechaAc.toLocaleDateString("es-MX", {
      timeZone: "America/Mazatlan",
    });
    const [dia, mes, year] = f2l.split('/');
    let mesAc = mes;
    let diaAc = dia;
    if (mes.length == 1) {
      mesAc = `0${mes}`;
    }
    if (dia.length == 1) {
      diaAc = `0${dia}`;
    }
    const fech = `${year}-${mesAc}-${Number(dia)}`;
    this.fechaFinal.setValue(fech);
    this.fechaInicial.setValue(fech);
    console.log(fech);
  }

  getDatosGrls(query) {

    this.encuestaService.consultaEnvios(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token, query, this.classUser.canale.url_back).subscribe(
      async (res: any) => {
        // console.log(res)
        const { status, message } = res;
        if (status === 'success') {
          const { nEnviados,
            nrecibidos,
            nRespondidas } = res;
          this.enviados = nEnviados;
          this.recibidos = nrecibidos;
        }
      },
      err => {
        console.log(err);
      });

  }

  descargar() {
    const fechaInicioDate = new Date(this.fechaInicial.value);
    const fechaFinDate = new Date(this.fechaFinal.value);
    const MILISEGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
    const diferenciaDias = (fechaFinDate.getTime() - fechaInicioDate.getTime()) / MILISEGUNDOS_POR_DIA;

    if (diferenciaDias <= 90) {
      this.descarga = true;
      if (this.fechaInicial.value) {
        this.consulta(1, 0);
      } else {
        this.consulta(0, 0);
      }
    } else {
      this.presentToast('No se puede realizar una descarga mayor a 3 meses', 'danger');
    }
    this.descarga = false;
  }

  resetFiltro() {
    this.getFechaActual();
    this.tel.reset();
    this.fechaFinal.reset();
    this.fechaInicial.reset();
    this.dataFiltro = {};
    this.arrFiltro = {};
    this.totalFiltro = 0;
  }

  busqueda(ev) {
    // console.log(ev);
    this.tel.setValue(ev.detail.value);
    if (this.tel.value) {
      this.dataFiltro.numero = `&numero=${this.tel.value}`;
    } else {
      this.dataFiltro.numero = ``;
    }
    // console.log(this.dataFiltro.numero, this.tel.value);
  }

  menosPag() {
    // console.log(this.pagina, this.paginacion, 'menos');
    if (this.paginacion > 0) {
      this.paginacion = this.paginacion - 30;
      this.pagina = this.pagina - 1;
    }

    if (this.fechaInicial.value) {
      this.consulta(1, 0);
    } else {
      this.consulta(0, 0);
    }

    // console.log(this.pagina, this.paginacion, 'menos');
  }

  masPag() {
    // console.log(this.pagina, this.paginacion, 'mas');
    this.paginacion = this.paginacion + 30;
    this.pagina = this.pagina + 1;

    if (this.fechaInicial.value) {
      this.consulta(1, 0);
    } else {
      this.consulta(0, 0);
    }
    // console.log(this.pagina, this.paginacion, 'mas');
  }

  async openMdlFiltro() {
    let id;
    // if(tipo == 1) {
    //   id = this.idStatus;
    // } else if(tipo == 2) {
    //   id = this.idAgente;
    // } else {
    //   id = this.origen.value;
    // }
    const modal = await this.modalCtrl.create({

      component: MdlFiltroPage,
      componentProps: {
        dataInfo: this.classUser,
        arrFiltro: this.arrFiltro,
        reporte: 1
      },
      mode: 'ios',
      cssClass: 'modalFiltro'
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
    this.arrFiltro = data.filtro;
    if (data.filtro.agentes.length > 0) {
      this.dataFiltro.agente = data.filtro.agentes;
    } else {
      this.dataFiltro.agente = [];
    }
    if (data.filtro.resultados.length > 0) {
      this.dataFiltro.resultado = data.filtro.resultados;
    } else {
      this.dataFiltro.resultado = [];
    }
    if (data.filtro.origen.length > 0) {
      this.dataFiltro.origen = data.filtro.origen;
    } else {
      this.dataFiltro.origen = [];
    }

    if (data.filtro.equipo.length > 0) {
      this.dataFiltro.equipo = data.filtro.equipo;
    } else {
      this.dataFiltro.equipo = [];
    }
    this.totalFiltro = data.filtro.agentes.length + data.filtro.resultados.length + data.filtro.origen.length + data.filtro.equipo.length;
    // console.log(this.arrFiltro, this.dataFiltro);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      //message: mensaje,
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png" ></ion-img>'
    });
    await this.loading.present();
  }

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

  vistaAnterior() {
    this.masivosService.setMostrarMasivos(true);
    this.masivosService.setMostrarReporteEncuestas(false);
  }

}
